import { render } from "./AppVersion.component.vue?vue&type=template&id=58676ac2"
import script from "./AppVersion.component.vue?vue&type=script&lang=js"
export * from "./AppVersion.component.vue?vue&type=script&lang=js"

import "./AppVersion.component.vue?vue&type=style&index=0&id=58676ac2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__